const LAST_PROJECT_ID_KEY = 'lastSelectedProjectId'

export const projectStorage = {
  getLastProjectId: (): string | null => {
    if (typeof window === 'undefined') return null
    return localStorage.getItem(LAST_PROJECT_ID_KEY)
  },

  setLastProjectId: (projectId: string): void => {
    if (typeof window === 'undefined') return
    localStorage.setItem(LAST_PROJECT_ID_KEY, projectId)
  },

  clearLastProjectId: (): void => {
    if (typeof window === 'undefined') return
    localStorage.removeItem(LAST_PROJECT_ID_KEY)
  },
}
